import { FC } from 'react';

import { CraneLoadUnload } from '@/modules/Cranes/pages/CraneLoadUnload.tsx';

export namespace CraneRoutes {
  export const Cranes: FC = () => <CraneLoadUnload />;
}
